import { useStaticQuery, graphql } from "gatsby"

const useOffice = props => {
  var office_crm_id, main_office, Office_Email_Id
  office_crm_id = props

  const office = useStaticQuery(graphql`
    query {
      glstrapi {
        offices(where: { Publish: true }) {
          CRM_ID
          Office_Email_Id
        }
      }
    }
  `)

  const all_offices = office?.glstrapi?.offices

  if (office_crm_id) {
    main_office = all_offices
      .filter(item => item.CRM_ID === office_crm_id)
      .pop()
    Office_Email_Id =
      (main_office !== undefined || main_office !== null) &&
      main_office?.Office_Email_Id
  }

  return Office_Email_Id
}

export default useOffice
